import axios from 'axios'

export const getDeliveryAreas = async (params = {}) => {
  const response = await axios.get('delivery-area', {
    params: {
      page: params.page || 1,
      take: params.take || 50,
      ...params,
    },
  })
  return response.data.data
}

export const pullDeliveryAreasFromSap = async () => {
  const response = await axios.get('delivery-area/pull')
  return response.data
}

